import { Expose } from 'class-transformer';

export class PrequalificationParseFromExcelModel {
  @Expose()
  preQualifications: {
    person: any;
    maritalStatusCode: number;
  }[][];
}
